import styled from "styled-components";

export const FooterSection = styled.footer`
  background: var(--ink-deep);
  color: var(--on-ink-muted);
  padding: clamp(3.5rem, 6vw, 5rem) 0 2rem;
  font-size: 0.9375rem;
`;

export const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 2.5rem;
  padding-bottom: 3rem;
  border-bottom: 3px double rgba(233, 239, 236, 0.22);

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const Brand = styled.div`
  img {
    display: block;
    width: 150px;
    height: auto;
    /* El logotipo es tinta oscura: se invierte a blanco sobre fondo oscuro */
    filter: brightness(0) invert(1);
    opacity: 0.92;
  }
`;

export const BrandText = styled.p`
  margin-top: 1.25rem;
  max-width: 22rem;
  font-size: 0.9375rem;
  color: var(--on-ink-muted);
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;

  a {
    color: var(--on-ink);
    align-self: flex-start;
    border-bottom: 1px solid transparent;
    &:hover { color: #fff; border-bottom-color: var(--ledger-on-ink); }
  }

  span { color: var(--on-ink); }
`;

export const ColumnTitle = styled.h4`
  font-family: var(--font-display);
  font-size: 1.125rem;
  color: #fff;
  margin-bottom: 0.5rem;
`;

export const Legal = styled.p`
  padding-top: 1.5rem;
  font-size: 0.8125rem;
  color: var(--on-ink-muted);
`;
